module.exports = __webpack_public_path__ + "static/media/dots.bd61e6ef.svg";